const notificationsData = [
{
  id: 1,
  title: "🎓 ¡Felicidades!",
  message: "Todos los estudiantes recibirán su certificado. Has completado tu formación.",
  buttonText: "Cerrar",
  route: "#"
},
 {
  id: 2,
  title: "📘 Bootcamps",
  message: "Ya tienes acceso al módulo de contratos inteligentes. La próxima semana se abrirán los siguientes videos del bootcamp.",
  buttonText: "Ir al curso",
  route: "/course/bootcamps"
},
{
  id: 3,
  title: "📅 Proyecto disponible",
  message: "El proyecto quedará abierto durante un mes para que puedas terminarlo con calma después del bootcamp de Solidity.",
  buttonText: "Ver proyecto",
  route: "/course/fame-projects"
},
{
  id: 4,
  title: "📅 Bootcamp Ley Fintech actualizado",
  message: "El bootcamp de la Ley Fintech se ha actualizado y ya está disponible.",
  buttonText: "Ver bootcamp",
  route: "/course/bootcamps"
},
{
  id: 5,
  title: "🎓 Certificado en proceso de aprobación",
  message: "El certificado está siendo aprobado por la SEP. En cuanto esté listo, podrás descargarlo y mintearlo desde la plataforma.",
  buttonText: "Ver certificado",
  route: "#"
},
{
  id: 6,
  title: "🧪 Simuladores actualizados",
  message: "Ya puedes acceder a los simuladores para comenzar tus primeras prácticas de blockchain. ¡Explora y experimenta!",
  buttonText: "Ir a simuladores",
  route: "/course/simuladores"
},
{
  id: 7,
  title: "🔗 Subir prácticas (PDF)",
  message: "Ya puedes acceder a la carga  para comenzar tus primeras prácticas de blockchain. ¡Explora y experimenta!",
  buttonText: "Ir a PDF Loader",
  route: "/course/token-project-viewer/pdf",
}


];

export default notificationsData;
